import * as Mui from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { ContextOperation } from "../../../context/OperationContext";
import useOperationTranslation from "../../../hooks/useOperationTranslation";
import useSnackbar from "../../../hooks/useSnackbar";
import OperationTypes from "../../../types";
import VehicleAvailabilityService, { EnumStatusReasons } from "../service/VehicleAvailabilityService";

interface Props {
  tenant:string;
  open: boolean;
  onClose: () => void;
  vehicleId: number;
  currentStatus: string;
  onChangeStatus: (status: OperationTypes.VehicleAvailability.Status) => void;
  vehiclePlate: string;
}

const ChangeStatus = (props: Props) => {
  const [statusReasons, setStatusReasons] = useState<OperationTypes.Domain[]>([]);

  const snackbar = useSnackbar();
  const t = useOperationTranslation();
  const { setLoading } = useContext(ContextOperation);
  
  useEffect(() => {
    VehicleAvailabilityService.get.availabilityStatusReasons(props.tenant,EnumStatusReasons.AVAILABLE, false, props.vehiclePlate).then(
      response => setStatusReasons(response),
    );
  }, []);

  const onChangeStatus = (availabilityCode: string) => {
    if (availabilityCode === props.currentStatus) {
      props.onClose();
      return;
    }

    setLoading(true);
    VehicleAvailabilityService.update.changeAvailabilityReason(props.tenant,props.vehicleId, availabilityCode).then(
      response => {
        props.onChangeStatus(response);
        snackbar.show("success", t("vehicleAvailability.status.changeAvailabilityStatus.succesfull"));
        setLoading(false);
        props.onClose();
      },
      reject => {
        snackbar.show("error", t("vehicleAvailability.status.changeAvailabilityStatus.error"));
        setLoading(false);
        props.onClose();
      }
    )
  }

  return (
    <Mui.Dialog open={props.open} onClose={props.onClose}>
      <Mui.DialogContent>
        <Mui.Typography textAlign="center" variant="h6">
          {t("vehicleAvailability.status.changeAvailabilityStatus.title")}
        </Mui.Typography>

        <Mui.Stack gap={2} mt={2.5}>
          {statusReasons.map(status => {
            const isActive = props.currentStatus === status.code;
            return (
              <Mui.Button
                variant="contained"
                color={isActive ? "primary" : "accent"}
                onClick={() => onChangeStatus(status.code)}
              >
                {status.descr}
              </Mui.Button>
            )
          })}
        </Mui.Stack>
      </Mui.DialogContent>
    </Mui.Dialog>
  )
}

export default ChangeStatus;